import { render, staticRenderFns } from "./OverlayFnDetailsButton.vue?vue&type=template&id=db99e93a&"
import script from "./OverlayFnDetailsButton.vue?vue&type=script&lang=js&"
export * from "./OverlayFnDetailsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports